export const CFO_LANG_STORAGE_KEY = "cfo-lang";

const shared = {
  whatsapp: {
    es: {
      cfo: "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20asesor%C3%ADa%20sobre%20Direcci%C3%B3n%20financiera%20externa%20con%20MEU%20Aliado.",
      serviciosSolicitud:
        "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20un%20servicio%20complementario%20de%20Direcci%C3%B3n%20financiera%20externa.%20%C2%BFPodemos%20conversar%3F",
      serviciosEspecializados:
        "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20asesor%C3%ADa%20sobre%20un%20proyecto%20especializado%20de%20Direcci%C3%B3n%20financiera%20externa.%20%C2%BFPodemos%20conversar%3F",
      diagnostico:
        "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20el%20Diagn%C3%B3stico%20Financiero%20Inicial.%20%C2%BFPodemos%20agendar%3F",
      clientesAgendas:
        "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20la%20automatizaci%C3%B3n%20de%20gesti%C3%B3n%20de%20clientes%20y%20agendas.%20%C2%BFPodemos%20conversar%3F",
      facturacionElectronica:
        "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20la%20facturaci%C3%B3n%20electr%C3%B3nica.%20%C2%BFPodemos%20conversar%3F",
    },
    en: {
      cfo: "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20external%20financial%20direction%20with%20MEU%20Aliado.",
      serviciosSolicitud:
        "https://wa.me/573213213635?text=Hello%2C%20I%27d%20like%20to%20request%20a%20complementary%20service%20for%20external%20financial%20direction.%20Can%20we%20talk%3F",
      serviciosEspecializados:
        "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20a%20specialized%20external%20financial%20direction%20project.%20Can%20we%20schedule%20a%20call%3F",
      diagnostico:
        "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20the%20Initial%20Financial%20Diagnosis.%20Can%20we%20schedule%20a%20call%3F",
      clientesAgendas:
        "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20automated%20client%20and%20schedule%20management.%20Can%20we%20talk%3F",
      facturacionElectronica:
        "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20electronic%20invoicing.%20Can%20we%20talk%3F",
    },
  },
};

export const cfoTranslations = {
  es: {
    landing: {
      badge: "Dirección de innovación financiera",
      heroTitle: "Dirección de innovación financiera",
      heroSubtitle:
        "Acceda a dirección financiera de alto nivel sin contratar un equipo financiero de tiempo completo. Modelo flexible de suscripción mensual, con aliados en consultoría estratégica, comercial y de talento humano.",
      ctaPlans: "Ver planes y servicios",
      ctaInfo: "Solicitar información",
      heroQuote1: "Construyamos juntos la empresa del mañana.",
      heroQuote2:
        "Hoy, acceder a dirección financiera de alto nivel nunca fue tan sencillo — y los grandes proyectos prosperan cuando los mejores están detrás de cada decisión.",
      nav: [
        { label: "Cómo empezar", targetId: "ruta" },
        { label: "El reto", targetId: "reto" },
        { label: "La solución", targetId: "solucion" },
        { label: "Impacto", targetId: "impacto" },
        { label: "Alianza", targetId: "alianza" },
        { label: "Equipo", targetId: "equipo" },
        { label: "Portafolio", targetId: "portafolio" },
      ],
      journey: {
        label: "Cómo empezar",
        title: "Una ruta en tres fases que reduce la fricción comercial",
        subtitle:
          "En Colombia, muchos empresarios prefieren conocer primero a quien los acompañará antes de comprometerse con un plan mensual. Por eso proponemos empezar con un diagnóstico con entregables claros y escalar solo cuando tenga sentido.",
        recommended: "Punto de partida recomendado",
        deliverablesLabel: "Entregas",
        phases: [
          {
            phase: "Fase 1",
            title: "Diagnóstico Financiero Ejecutivo",
            summary:
              "Evaluación inicial sin costo (5–10 días hábiles) con metodología F.I.N.A.N.Z.A.S. 360® para identificar fortalezas, riesgos y oportunidades.",
            deliverables: ["Resumen ejecutivo", "Hallazgos", "Riesgos", "Oportunidades", "Roadmap preliminar"],
            bridge:
              "Si desea implementar estas recomendaciones, podemos hacerlo mediante un esquema de dirección de innovación financiera.",
            cta: "Solicitar diagnóstico",
            ctaType: "whatsapp",
            secondaryCta: "Ver guía metodológica",
            secondaryCtaHref: "/empresas/direccion-de-innovacion-financiera/diagnostico",
            recommended: true,
          },
          {
            phase: "Fase 2",
            title: "Dirección de innovación financiera",
            summary: "Acompañamiento recurrente con reuniones, reportes e indicadores — planes Essential, Growth y Strategic.",
            description:
              "Modelo de suscripción mensual flexible. Consulte inversión, alcance y comparativo en la página de planes.",
            cta: "Ver planes y servicios",
            ctaType: "link",
            ctaHref: "/empresas/direccion-de-innovacion-financiera/planes",
          },
          {
            phase: "Fase 3",
            title: "Proyectos especiales",
            summary: "Alcance y cotización definidos según la complejidad y el tamaño de cada proyecto.",
            deliverables: [
              "Levantamiento de capital",
              "Valoraciones",
              "Modelos financieros",
              "M&A",
              "Due diligence",
              "Coberturas financieras",
              "Gestión de portafolios",
            ],
            cta: "Consultar proyecto",
            ctaType: "whatsapp-specialized",
          },
        ],
      },
      whatIsTitle: "¿Qué es la dirección de innovación financiera?",
      whatIsBody:
        "Un acompañamiento financiero recurrente — con reuniones, reportes e indicadores — que brinda a su empresa capacidades de planeación y control sin el costo fijo de una contratación permanente. En MEU Aliado lo integramos con el portafolio estratégico, comercial y de talento de Open Options cuando su negocio lo requiere.",
      challengeLabel: "El reto",
      challengeTitle: "La mayoría de las PYMEs en Colombia no tienen dirección financiera dedicada",
      challengeBody:
        "Las pequeñas y medianas empresas impulsan la economía, pero suelen gestionar las finanzas de forma reactiva: venden, operan y resuelven la caja mes a mes, sin una función dedicada a la planeación estratégica.",
      challenges: [
        "Operan con información financiera desactualizada o incompleta.",
        "Toman decisiones de crecimiento sin proyección de caja ni escenarios.",
        "Dependen del banco como única fuente de financiamiento, sin alternativas estructuradas.",
        "No cuentan con dirección financiera dedicada porque el costo de un equipo de tiempo completo aún no es viable.",
      ],
      metrics: [
        {
          valor: "+60%",
          etiqueta: "Microempresas sin registros financieros formales",
          fuente: "Termómetro Empresarial Biru, 2025 (Portafolio)",
        },
        {
          valor: "80%",
          etiqueta: "Pequeños empresarios que deciden con intuición, no con datos",
          fuente: "HeatMaps · estudios sobre PYMEs en Colombia",
        },
        {
          valor: "17%",
          etiqueta: "Aplica análisis financiero, presupuesto y control de costos",
          fuente: "Termómetro Empresarial Biru, 2025 (Portafolio)",
        },
      ],
      sourcesLabel: "Fuentes:",
      solutionLabel: "Nuestra solución",
      solutionTitle: "Dirección de innovación financiera bajo suscripción mensual",
      solutionBody:
        "Le damos a su empresa planeación, análisis, indicadores y apoyo en decisiones estratégicas — con la flexibilidad que una PYME en crecimiento necesita y la posibilidad de activar consultores de Open Options en estrategia, comercial y talento.",
      solutionItems: [
        "Planeación financiera y presupuestal",
        "Seguimiento de flujo de caja e indicadores",
        "Apoyo en financiación e inversionistas",
      ],
      ctaPlansFull: "Ver planes y servicios",
      impactLabel: "Por qué explorar esta opción",
      impactTitle: "Tres áreas que su empresa puede mejorar",
      impactSubtitle:
        "La dirección de innovación financiera no reemplaza la contabilidad: complementa la gerencia con visión financiera para decidir mejor.",
      impactCards: [
        {
          titulo: "Control de caja",
          metrica: "Liquidez anticipada",
          descripcion:
            "Identifique con semanas de anticipación presiones de caja y evite decisiones reactivas que comprometan la operación.",
        },
        {
          titulo: "Rentabilidad real",
          metrica: "Márgenes visibles",
          descripcion:
            "Conozca qué líneas de negocio generan valor y cuáles destruyen rentabilidad, con indicadores claros para la gerencia.",
        },
        {
          titulo: "Crecimiento sostenible",
          metrica: "Expansión con respaldo",
          descripcion:
            "Evalúe proyectos, expansiones y necesidades de capital con modelos financieros antes de comprometer recursos.",
        },
      ],
      cfoLabel: "Liderazgo financiero",
      cfoTitle: "Su dirección de innovación financiera",
      ceoBadge: "CEO & Co-founder · MEU Aliado",
      julianRole: "Dirección de innovación financiera · MeuDoc & MEU Aliado · Estrategia empresarial",
      linkedinCta: "Ver perfil en LinkedIn →",
      contactTitle: "Información de contacto",
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
      linkedinLabel: "LinkedIn",
      ctaAdvisory: "Solicitar asesoría",
      contactNote: "Escríbame y exploremos soluciones que se ajusten a las necesidades de su empresa.",
      bioDegree: "Economista · Universidad de los Andes · Maestría PEG en Economía (2025 – 2027)",
      bioText:
        "Apasionado por las finanzas, el modelaje cuantitativo, el fintech y las relaciones corporativas de alto impacto en Colombia. Ha promovido iniciativas de emprendimiento desde la Universidad de los Andes, ejerció como monitor del Laboratorio de Finanzas y cuenta con una amplia red de contactos en el sector financiero Colombiano.",
      strategyTitle: "Estrategia y comercial",
      strategyTextBefore: "CEO y Co-fundador de",
      strategyTextAfter:
        ", liderando la visión estratégica, el crecimiento comercial y el relacionamiento con inversionistas en ambos ecosistemas.",
      cfoExpTitle: "Experiencia en dirección financiera",
      cfoExpText:
        "Seis años como director financiero de Lh Inversiones Acuarios Ltda. (NIT: 800080813), con experiencia en relacionamiento con inversionistas y financiamiento vía levantamiento de capital como alternativa al crédito bancario tradicional.",
      experience: [
        "Seis años liderando la dirección financiera de Lh Inversiones Acuarios Ltda. (NIT 800080813).",
        "Experiencia en relacionamiento con inversionistas y financiamiento alternativo al crédito bancario.",
        "Estratega de relaciones públicas y análisis financiero en PRO Investing | PRO Capital Management.",
        "Monitor del Laboratorio de Finanzas de la Universidad de los Andes (2022 – 2024).",
      ],
      skills: "Python · Excel · Power BI · Bloomberg",
      languages: "Español (nativo) · Inglés (avanzado)",
      alliance: {
        label: "Alianza estratégica",
        title: "MEU Aliado + Open Options",
        alliedBadge: "Empresa aliada",
        body:
          "Open Options es nuestra empresa aliada en consultoría estratégica, comercial y de talento humano. Juntos ofrecemos dirección de innovación financiera con task forces a la medida para acelerar el crecimiento rentable y sostenido de su empresa.",
        openOptionsTagline: "Empresa aliada · Consultores estratégicos comerciales y talento humano",
        openOptionsUrl: "https://www.openoptions.co/",
        openOptionsCta: "Conocer Open Options",
        taskForceTitle: "Task force conjunto",
        taskForceBody:
          "Conformamos equipos integrados con su organización para resolver retos específicos: planeación financiera, estrategia corporativa, fuerza comercial, indicadores de gestión o desarrollo de personas — con facilitación y acompañamiento en la ejecución.",
        clientsLabel: "Nuestros clientes",
        clientsIntro:
          "A través de nuestra empresa aliada Open Options, hemos acompañado organizaciones de consumo masivo, sector financiero, sector público y manufactura en Colombia y la región.",
        clients: [
          "Consumo masivo: Coca-Cola FEMSA, Alpina, Condimentos El Rey, Grasco y Belcorp.",
          "Sector financiero: Banco Ganadero (hoy BBVA) y banca corporativa en Colombia.",
          "Sector público y proyectos nacionales: PNUD, Ministerio de Hacienda, UGPP y Planeación Nacional.",
          "Manufactura y servicios en Colombia y Venezuela, con cargos directivos en multinacionales.",
        ],
      },
      teamSection: {
        label: "Equipo y experiencia",
        title: "Quién lidera su estrategia financiera",
        subtitle:
          "Profesionales de MEU Aliado lideran su estrategia financiera, con el respaldo institucional y la experiencia de Open Options en estrategia, comercial y talento humano.",
        unifiedLabel: "Equipo MEU Aliado",
        openOptionsExperienceLabel: "Experiencia de nuestra empresa aliada",
        openOptionsExperienceTitle: "Trayectoria de Open Options",
        openOptionsExperienceIntro:
          "Su experiencia reúne más de tres décadas de liderazgo y consultoría en organizaciones nacionales y multinacionales.",
      },
      meuTeam: [
        {
          id: "sebastian-villamil",
          name: "Sebastian Villamil",
          role: "Finanzas corporativas y capital privado",
          focus:
            "Economista de la Universidad de los Andes. Experto en capital privado y finanzas corporativas — estructuración de inversiones, valoración y transacciones corporativas de alto impacto.",
        },
      ],
      openOptionsTeam: [
        {
          name: "Manuel F. Cortes N.",
          role: "Director",
          focus:
            "Más de 30 años en gerencia integral. Coca-Cola FEMSA y Banco Ganadero (BBVA). Mercadeo, finanzas, administración y desarrollo humano.",
        },
        {
          name: "Luz Marina Lozada A.",
          role: "Partner",
          focus:
            "Más de 30 años en sector bancario y Ministerio de Hacienda. Procesos organizacionales, BPM y proyectos con PNUD y UGPP.",
        },
        {
          name: "Lineth Rodriguez Ruge",
          role: "Partner",
          focus:
            "Coach ejecutiva y mercadeo. Experiencia directiva en Alpina, El Rey, Belcorp y Grasco. Facilitación de equipos comerciales.",
        },
        {
          name: "José Luis Salas H.",
          role: "Partner",
          focus:
            "MBA (USC) y especialista en finanzas. Desarrollo estratégico, administrativo y comercial en consumo masivo y servicios.",
        },
        {
          name: "Leidy Ramírez",
          role: "Partner",
          focus:
            "Comunicación, diseño e imagen corporativa. Branding, editorial e impresión para fortalecer la propuesta comercial.",
        },
      ],
      portfolioComplementario: {
        label: "Portafolio complementario",
        title: "Un ecosistema de soluciones para su empresa",
        subtitle:
          "Además de la dirección de innovación financiera de MEU Aliado, puede activar el portafolio de Open Options — nuestra empresa aliada — en tres ejes: estratégico, comercial y de talento humano, con herramientas de inteligencia de negocio (BI).",
        downloadPdf: "Descargar portafolio ejecutivo (PDF)",
        downloadPdfHint: "Portafolio corporativo con servicios, equipo y alianza Open Options.",
        meuTitle: "Dirección de innovación financiera · MEU Aliado",
        meuItems: [
          "Diagnóstico financiero inicial y roadmap de 90 días.",
          "Planes Essential, Growth y Strategic con indicadores y flujo de caja.",
          "Proyectos especiales: valoraciones, modelos, M&A, due diligence y financiación.",
        ],
        meuCta: "Ver planes y servicios",
        openOptionsCta: "Explorar Open Options",
        pillars: [
          {
            title: "Desarrollo estratégico",
            items: [
              "Plan estratégico de corto, mediano y largo plazo.",
              "Estructura organizacional y gestión por procesos.",
              "Sistemas de gestión y certificación.",
              "Indicadores de gestión e inteligencia empresarial (Power BI).",
            ],
          },
          {
            title: "Desarrollo comercial",
            items: [
              "Acompañamiento de fuerzas de ventas.",
              "Mystery shopper y experiencia de compra.",
              "Investigaciones de mercado.",
              "Planes de mercadeo y posicionamiento.",
            ],
          },
          {
            title: "Desarrollo humano",
            items: [
              "Assessment ejecutivo y coaching.",
              "Sistemas de remuneración y beneficios.",
              "Desarrollo de competencias individuales y de equipos.",
              "Capacitación, entrenamiento y evaluación de riesgo psicosocial.",
            ],
          },
        ],
      },
    },
    planes: {
      backLink: "Volver a dirección de innovación financiera",
      eyebrow: "Planes y servicios",
      title: "Dirección de innovación financiera",
      subtitle: "Precios, comparativo de planes, alcance del servicio, diagnóstico inicial y condiciones de contratación.",
      downloadPdf: "Descargar portafolio ejecutivo (PDF)",
      nav: [
        { label: "Cómo empezar", targetId: "ruta" },
        { label: "Comparativo", targetId: "comparativo" },
        { label: "Planes", targetId: "detalle-planes" },
        { label: "No incluidos", targetId: "no-incluidos" },
        { label: "Adicionales", targetId: "adicionales" },
        { label: "Condiciones", targetId: "condiciones" },
      ],
      journey: {
        label: "Cómo empezar",
        title: "Una ruta en tres fases",
        subtitle:
          "Precios de referencia para cada etapa: diagnóstico inicial, acompañamiento mensual y proyectos puntuales.",
        recommended: "Punto de partida recomendado",
        suggestedPlan: "Plan sugerido",
        deliverablesLabel: "Entregas",
        investmentLabel: "Inversión",
        phases: [
          {
            phase: "Fase 1",
            title: "Diagnóstico financiero inicial",
            summary: "Entrada de bajo riesgo para entender el estado financiero y las prioridades de su empresa.",
            price: "COP $1.200.000",
            priceNote: "Rango orientativo: COP $800.000 – COP $1.500.000",
            deliverables: ["Diagnóstico", "Hallazgos", "Recomendaciones", "Roadmap de 90 días"],
            bridge:
              "Si desea implementar estas recomendaciones, podemos hacerlo mediante un esquema de dirección de innovación financiera.",
            cta: "Solicitar diagnóstico",
            ctaType: "whatsapp",
            recommended: true,
          },
          {
            phase: "Fase 2",
            title: "Dirección de innovación financiera",
            summary: "Acompañamiento recurrente con reuniones, reportes e indicadores — planes Essential, Growth y Strategic.",
            price: "COP $2.000.000 – COP $6.000.000",
            priceNote: "mensuales",
            suggestedPlanName: "Growth",
            suggestedPlanPrice: "$3.500.000",
            description:
              "Growth equilibra profundidad de análisis y dedicación para empresas en crecimiento. Consulte el comparativo para ver alcance por plan.",
            cta: "Ver comparativo de planes",
            ctaType: "anchor",
            ctaHref: "#comparativo",
            suggested: true,
          },
          {
            phase: "Fase 3",
            title: "Proyectos especiales",
            summary: "Alcance y cotización definidos según la complejidad y el tamaño de cada proyecto.",
            price: "Cotización independiente",
            deliverables: [
              "Levantamiento de capital",
              "Valoraciones",
              "Modelos financieros",
              "M&A",
              "Due diligence",
              "Coberturas financieras",
              "Gestión de portafolios",
            ],
            cta: "Consultar proyecto",
            ctaType: "whatsapp-specialized",
          },
        ],
      },
      comparativoTitle: "Comparativo de planes",
      tableFeature: "Característica",
      includedAria: "Incluido",
      ctaWhatsapp: "Solicitar asesoría por WhatsApp",
      recommended: "Recomendado",
      planPrefix: "Plan",
      monthlyInvestment: "Inversión mensual",
      includes: "Incluye",
      notIncludedTitle: "Servicios bajo solicitud",
      notIncludedP1:
        "Los siguientes servicios no hacen parte del alcance estándar de la dirección de innovación financiera dentro de los planes Essential, Growth y Strategic.",
      notIncludedP2:
        "Aun así, sí los ofrecemos y podemos realizarlos bajo solicitud, con alcance, tiempos y honorarios acordados de forma independiente. Escríbanos por WhatsApp y revisamos juntos qué necesita su empresa.",
      featuredServicesLabel: "Destacados de MEU Aliado",
      featuredCta: "Me interesa",
      requestWhatsapp: "Solicitar por WhatsApp",
      additionalLabel: "Servicios adicionales",
      specializedTitle: "Servicios Especializados",
      tableService: "Servicio",
      tableDescription: "Descripción",
      tableDeliverables: "Entregables incluidos*",
      tableInvestment: "Inversión de referencia*",
      conditionsTitle: "Condiciones generales",
    },
    data: {
      planes: [
        {
          nombre: "Essential",
          precio: "$2.000.000",
          horas: "4 a 6 horas mensuales",
          destacado: false,
          descripcion:
            "Dirigido a empresas que requieren visibilidad financiera básica y seguimiento periódico de sus resultados.",
          incluye: [
            "Dashboard financiero mensual.",
            "Seguimiento de ingresos, costos y márgenes.",
            "Monitoreo básico de flujo de caja.",
            "Reunión mensual de seguimiento.",
            "Informe ejecutivo con hallazgos y recomendaciones.",
          ],
        },
        {
          nombre: "Growth",
          precio: "$3.500.000",
          horas: "8 a 12 horas mensuales",
          destacado: true,
          descripcion:
            "Dirigido a empresas en crecimiento que necesitan planeación financiera y control permanente del negocio.",
          incluye: [
            "Todo lo del Plan Essential.",
            "Modelo financiero.",
            "Forecast de ingresos y gastos.",
            "Planeación de caja.",
            "Seguimiento de indicadores estratégicos.",
            "Análisis periódico de rentabilidad.",
            "Dos reuniones mensuales.",
          ],
        },
        {
          nombre: "Strategic",
          precio: "$6.000.000",
          horas: "16 a 24 horas mensuales",
          destacado: false,
          descripcion:
            "Dirigido a empresas que requieren acompañamiento financiero de alto nivel para crecimiento, expansión o búsqueda de financiación.",
          incluye: [
            "Todo lo del Plan Growth.",
            "Evaluación financiera de nuevos proyectos.",
            "Análisis de expansión.",
            "Apoyo en procesos de financiación.",
            "Preparación de información para inversionistas.",
            "Participación en reuniones estratégicas.",
            "Disponibilidad prioritaria.",
          ],
        },
      ],
      comparativoPlanes: [
        { caracteristica: "Inversión mensual", essential: "COP $2.000.000", growth: "COP $3.500.000", strategic: "COP $6.000.000" },
        { caracteristica: "Reuniones de seguimiento", essential: "1 mensual", growth: "2 mensuales", strategic: "Semanales" },
        { caracteristica: "Dashboard financiero", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Seguimiento de ingresos y gastos", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Seguimiento de márgenes", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Flujo de caja", essential: "Básico", growth: "Avanzado", strategic: "Avanzado" },
        { caracteristica: "Forecast financiero", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Modelo financiero", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "KPIs estratégicos", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Análisis de rentabilidad", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Evaluación de proyectos", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Análisis de expansión", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Apoyo en financiación", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Presentaciones para inversionistas", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Soporte por correo y WhatsApp", essential: "check", growth: "check", strategic: "Prioritario" },
      ],
      serviciosDestacados: [
        {
          id: "clientes-agendas",
          titulo: "Automatización de gestión de clientes y agendas automatizado",
          whatsapp: shared.whatsapp.es.clientesAgendas,
        },
        {
          id: "facturacion-electronica",
          titulo: "Facturación electrónica",
          whatsapp: shared.whatsapp.es.facturacionElectronica,
        },
      ],
      exclusiones: [
        "Contabilidad.",
        "Elaboración de declaraciones tributarias.",
        "Revisoría fiscal.",
        "Auditoría.",
        "Nómina.",
        "Servicios jurídicos.",
        "Implementación de software contable.",
        "Gestión operativa de cartera.",
        "Registro de transacciones contables.",
      ],
      serviciosEspecializadosIntro:
        "Además de la dirección de innovación financiera, ofrecemos proyectos financieros y estratégicos de alcance específico que pueden contratarse de manera independiente o complementaria. A través de la alianza con Open Options, también puede activar consultoría en estrategia, comercial y talento humano.",
      serviciosAdicionales: [
        {
          servicio: "Valoración de empresas",
          descripcion: "Estimación del valor económico de una compañía mediante metodologías financieras.",
          entregables: [
            "1 Excel — Modelo de valoración (DCF, comparables y sensibilidad).",
            "1 PDF — Informe ejecutivo de valoración (15–25 páginas).",
            "1 PowerPoint — Resumen para junta directiva (10–12 diapositivas).",
          ],
          inversion: "Desde COP $2.000.000",
        },
        {
          servicio: "Modelación financiera especializada",
          descripcion: "Construcción de modelos financieros para planeación, inversión o evaluación de escenarios.",
          entregables: [
            "1–2 Excel — Modelo financiero estructurado con escenarios base, optimista y estrés.",
            "1 PDF — Nota metodológica, supuestos y limitaciones (5–8 páginas).",
            "1 PowerPoint — Resumen de escenarios y conclusiones (8–10 diapositivas).",
          ],
          inversion: "Desde COP $1.500.000",
        },
        {
          servicio: "Business Plan",
          descripcion: "Elaboración de proyecciones financieras y documento de soporte para crecimiento o financiación.",
          entregables: [
            "1 Word / PDF — Documento Business Plan (25–40 páginas).",
            "1 Excel — Proyecciones financieras a 3–5 años (P&L, caja, balance).",
            "1 PowerPoint — Pitch deck para bancos o aliados (12–15 diapositivas).",
          ],
          inversion: "Desde COP $2.500.000",
        },
        {
          servicio: "Preparación para levantamiento de capital",
          descripcion: "Estructuración financiera, métricas e información para inversionistas.",
          entregables: [
            "1 Excel — Modelo financiero y métricas para data room.",
            "1 PowerPoint — Deck para inversionistas (15–20 diapositivas).",
            "1 PDF — One-pager + memo de estructura de capital (10–15 páginas).",
            "1 Word — Guía de Q&A y checklist de due diligence.",
          ],
          inversion: "Desde COP $3.000.000",
        },
        {
          servicio: "Due Diligence Financiero",
          descripcion: "Revisión y análisis financiero para procesos de inversión o adquisición.",
          entregables: [
            "1 Excel — Hallazgos, ajustes y estados normalizados.",
            "1 PDF — Informe de due diligence financiero (20–35 páginas).",
            "1 PowerPoint — Resumen ejecutivo para comité de inversión (8–10 diapositivas).",
          ],
          inversion: "Desde COP $4.000.000",
        },
        {
          servicio: "Estudios de mercado",
          descripcion: "Investigación sectorial, análisis competitivo y evaluación de oportunidades.",
          entregables: [
            "1 PDF — Informe de mercado y competencia (15–25 páginas).",
            "1 Excel — Datos sectoriales, benchmarks y tablas de soporte.",
            "1 PowerPoint — Conclusiones y oportunidades (10 diapositivas).",
          ],
          inversion: "Desde COP $2.000.000",
        },
        {
          servicio: "Evaluación financiera de adquisiciones",
          descripcion: "Análisis financiero y estratégico de potenciales adquisiciones o inversiones.",
          entregables: [
            "1 Excel — Modelo de adquisición, sinergias y retorno.",
            "1 PDF — Memo de recomendación go / no-go (12–18 páginas).",
            "1 PowerPoint — Resumen para decisión de directorio (8–12 diapositivas).",
          ],
          inversion: "Desde COP $3.500.000",
        },
        {
          servicio: "Diseño de indicadores gerenciales",
          descripcion: "Construcción de KPIs y dashboards para seguimiento del negocio.",
          entregables: [
            "1 Excel — Dashboard de KPIs con fórmulas y segmentación acordada.",
            "1 PDF — Diccionario de indicadores y metodología (8–12 páginas).",
            "1 PowerPoint — Presentación del tablero a gerencia (6–8 diapositivas).",
          ],
          inversion: "Desde COP $1.000.000",
        },
        {
          servicio: "Coberturas financieras",
          descripcion:
            "Diseño y acompañamiento en estrategias de cobertura para mitigar riesgos de tipo de cambio, tasas de interés u otros factores que afectan la operación o los resultados de la empresa.",
          entregables: [
            "1 Excel — Modelo de exposición y escenarios de cobertura.",
            "1 PDF — Memo de estrategia e instrumentos recomendados (8–15 páginas).",
            "1 PowerPoint — Propuesta para comité de riesgos (6–10 diapositivas).",
            "Alcance y cantidad de entregables personalizados según complejidad.",
          ],
          inversion: "Personalizadas",
        },
        {
          servicio: "Gestión de portafolios",
          descripcion:
            "Gestión de portafolios con estrategias acorde a ciclos económicos y del negocio. Gestionamos cuentas empresariales vía tercerización, sin incurrir en procesos de captación de fondos, mediante cuentas de gestión patrimonial con entidades reguladas para dicho fin.",
          entregables: [
            "1 PDF — Política de inversión y perfil de riesgo acordado.",
            "1 Excel — Reporte mensual de composición y rendimiento.",
            "1 PowerPoint — Revisión trimestral de portafolio (8–12 diapositivas).",
            "Reportes PDF periódicos emitidos por la entidad regulada (según contrato).",
          ],
          inversion: "Desde COP $150.000.000",
        },
      ],
      serviciosEspecializadosNota:
        "Los valores y cantidades de entregables son de referencia por proyecto. El alcance, complejidad, disponibilidad de información y tamaño de la empresa pueden modificar la cotización y el número de archivos (Excel, PDF, PowerPoint o Word) incluidos.",
      condicionesGenerales: [
        "Facturación mensual anticipada.",
        "Contrato de prestación de servicios.",
        "Permanencia mínima sugerida de tres (3) meses.",
        "Toda la información suministrada por la empresa será tratada de manera confidencial.",
      ],
    },
    whatsapp: shared.whatsapp.es,
  },
  en: {
    landing: {
      badge: "Financial innovation leadership",
      heroTitle: "Financial innovation leadership",
      heroSubtitle:
        "Access senior financial leadership without a full-time in-house finance team. A flexible monthly subscription model with Open Options as our allied company in strategic, commercial, and human talent consulting.",
      ctaPlans: "View plans and services",
      ctaInfo: "Request information",
      heroQuote1: "Let's build tomorrow's company together.",
      heroQuote2:
        "Today, access to senior financial leadership has never been easier — and great projects thrive when the best minds support every decision.",
      nav: [
        { label: "How to start", targetId: "ruta" },
        { label: "The challenge", targetId: "reto" },
        { label: "The solution", targetId: "solucion" },
        { label: "Impact", targetId: "impacto" },
        { label: "Alliance", targetId: "alianza" },
        { label: "Team", targetId: "equipo" },
        { label: "Portfolio", targetId: "portafolio" },
      ],
      journey: {
        label: "How to start",
        title: "A three-phase path that lowers commercial friction",
        subtitle:
          "In Colombia, many business owners prefer to know who they'll work with before committing to a monthly plan. That's why we start with a diagnosis that delivers clear outputs — and scale only when it makes sense.",
        recommended: "Recommended starting point",
        deliverablesLabel: "Deliverables",
        phases: [
          {
            phase: "Phase 1",
            title: "Executive Financial Diagnosis",
            summary:
              "Free initial assessment (5–10 business days) using the F.I.N.A.N.Z.A.S. 360® methodology to identify strengths, risks, and opportunities.",
            deliverables: ["Executive summary", "Findings", "Risks", "Opportunities", "Preliminary roadmap"],
            bridge:
              "If you'd like to implement these recommendations, we can do so through our financial innovation leadership engagement model.",
            cta: "Request diagnosis",
            ctaType: "whatsapp",
            secondaryCta: "View methodology guide",
            secondaryCtaHref: "/empresas/direccion-de-innovacion-financiera/diagnostico",
            recommended: true,
          },
          {
            phase: "Phase 2",
            title: "Financial innovation leadership",
            summary: "Recurring support with meetings, reports, and KPIs — Essential, Growth, and Strategic plans.",
            description:
              "Flexible monthly subscription model. See investment, scope, and plan comparison on the plans page.",
            cta: "View plans and services",
            ctaType: "link",
            ctaHref: "/empresas/direccion-de-innovacion-financiera/planes",
          },
          {
            phase: "Phase 3",
            title: "Special projects",
            summary: "Scope and pricing tailored to each project's complexity and size.",
            deliverables: [
              "Capital raising",
              "Valuations",
              "Financial models",
              "M&A",
              "Due diligence",
              "Financial hedging",
              "Portfolio management",
            ],
            cta: "Discuss a project",
            ctaType: "whatsapp-specialized",
          },
        ],
      },
      whatIsTitle: "What is financial innovation leadership?",
      whatIsBody:
        "Recurring financial support — with meetings, reports, and KPIs — that gives your company planning and control capabilities without the fixed cost of a permanent hire. At MEU Aliado we integrate it with Open Options' strategic, commercial, and human talent portfolio when your business needs it.",
      challengeLabel: "The challenge",
      challengeTitle: "Most SMEs in Colombia lack dedicated financial direction",
      challengeBody:
        "Small and mid-sized businesses drive the economy, but they often manage finances reactively: they sell, operate, and solve cash flow month by month, without a dedicated strategic planning function.",
      challenges: [
        "They operate with outdated or incomplete financial information.",
        "They make growth decisions without cash projections or scenarios.",
        "They rely on banks as their only funding source, without structured alternatives.",
        "They cannot afford dedicated financial direction with a full-time team yet.",
      ],
      metrics: [
        {
          valor: "+60%",
          etiqueta: "Micro-businesses without formal financial records",
          fuente: "Biru Business Thermometer, 2025 (Portafolio)",
        },
        {
          valor: "80%",
          etiqueta: "Small business owners who decide by intuition, not data",
          fuente: "HeatMaps · studies on SMEs in Colombia",
        },
        {
          valor: "17%",
          etiqueta: "Apply financial analysis, budgeting, and cost control",
          fuente: "Biru Business Thermometer, 2025 (Portafolio)",
        },
      ],
      sourcesLabel: "Sources:",
      solutionLabel: "Our solution",
      solutionTitle: "Financial innovation leadership on a monthly subscription",
      solutionBody:
        "We give your company planning, analysis, KPIs, and strategic decision support — with the flexibility a growing business needs, plus access to Open Options consultants in strategy, commercial, and talent when required.",
      solutionItems: [
        "Financial and budget planning",
        "Cash flow and KPI monitoring",
        "Support with funding and investors",
      ],
      ctaPlansFull: "View plans and services",
      impactLabel: "Why explore this option",
      impactTitle: "Three areas your company can improve",
      impactSubtitle:
        "Financial innovation leadership does not replace accounting: it complements management with financial insight for better decisions.",
      impactCards: [
        {
          titulo: "Cash control",
          metrica: "Anticipated liquidity",
          descripcion:
            "Identify cash pressures weeks in advance and avoid reactive decisions that compromise operations.",
        },
        {
          titulo: "Real profitability",
          metrica: "Visible margins",
          descripcion:
            "Know which business lines create value and which erode profitability, with clear indicators for management.",
        },
        {
          titulo: "Sustainable growth",
          metrica: "Backed expansion",
          descripcion:
            "Evaluate projects, expansion, and capital needs with financial models before committing resources.",
        },
      ],
      cfoLabel: "Financial leadership",
      cfoTitle: "Your financial innovation leadership",
      ceoBadge: "CEO & Co-founder · MEU Aliado",
      julianRole: "Financial innovation leadership · MeuDoc & MEU Aliado · Business strategy",
      linkedinCta: "View LinkedIn profile →",
      contactTitle: "Contact information",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
      ctaAdvisory: "Request advisory",
      contactNote: "Reach out and let's explore solutions tailored to your company's needs.",
      bioDegree: "Economist · Universidad de los Andes · MA in Economics (PEG), 2025 – 2027",
      bioText:
        "Passionate about finance, quantitative modeling, fintech, and high-impact corporate relationships in Colombia. He has promoted entrepreneurship initiatives at Universidad de los Andes, served as a monitor at the Finance Lab, and has an extensive network across Colombia's financial sector.",
      strategyTitle: "Strategy & commercial",
      strategyTextBefore: "CEO and Co-founder of",
      strategyTextAfter:
        ", leading strategic vision, commercial growth, and investor relations across both ecosystems.",
      cfoExpTitle: "Financial direction experience",
      cfoExpText:
        "Six years leading financial direction at Lh Inversiones Acuarios Ltda. (Tax ID: 800080813), with investor relations and capital raising as an alternative to traditional bank credit.",
      experience: [
        "Six years leading financial direction at Lh Inversiones Acuarios Ltda. (Tax ID 800080813).",
        "Experience with investors and alternative financing beyond bank credit.",
        "Public relations strategist and financial analyst at PRO Investing | PRO Capital Management.",
        "Monitor at Universidad de los Andes Finance Lab (2022 – 2024).",
      ],
      skills: "Python · Excel · Power BI · Bloomberg",
      languages: "Spanish (native) · English (advanced)",
      alliance: {
        label: "Strategic alliance",
        title: "MEU Aliado + Open Options",
        alliedBadge: "Allied company",
        body:
          "Open Options is our allied company in strategic, commercial, and human talent consulting. Together we deliver financial innovation leadership with tailored task forces to support profitable, sustainable growth.",
        openOptionsTagline: "Allied company · Strategic commercial and human talent consultants",
        openOptionsUrl: "https://www.openoptions.co/",
        openOptionsCta: "Discover Open Options",
        taskForceTitle: "Joint task force",
        taskForceBody:
          "We build integrated teams with your organization to solve specific challenges: financial planning, corporate strategy, sales force, management indicators, or people development — with facilitation and execution support.",
        clientsLabel: "Our clients",
        clientsIntro:
          "Through our allied company Open Options, we have supported organizations in mass consumption, financial services, public sector, and manufacturing across Colombia and the region.",
        clients: [
          "Mass consumption: Coca-Cola FEMSA, Alpina, Condimentos El Rey, Grasco, and Belcorp.",
          "Financial sector: Banco Ganadero (now BBVA) and corporate banking in Colombia.",
          "Public sector and national projects: UNDP, Ministry of Finance, UGPP, and National Planning.",
          "Manufacturing and services in Colombia and Venezuela, with leadership roles in multinationals.",
        ],
      },
      teamSection: {
        label: "Team and experience",
        title: "Who leads your financial strategy",
        subtitle:
          "MEU Aliado professionals lead your financial strategy, with Open Options' institutional backing and experience in strategy, commercial development, and human talent.",
        unifiedLabel: "MEU Aliado team",
        openOptionsExperienceLabel: "Experience of our allied company",
        openOptionsExperienceTitle: "Open Options track record",
        openOptionsExperienceIntro:
          "Its experience brings together more than three decades of leadership and consulting across national and multinational organizations.",
      },
      meuTeam: [
        {
          id: "sebastian-villamil",
          name: "Sebastian Villamil",
          role: "Corporate finance and private capital",
          focus:
            "Economist, Universidad de los Andes. Expert in private capital and corporate finance — investment structuring, valuation, and high-impact corporate transactions.",
        },
      ],
      openOptionsTeam: [
        {
          name: "Manuel F. Cortes N.",
          role: "Director",
          focus:
            "30+ years in general management. Coca-Cola FEMSA and Banco Ganadero (BBVA). Marketing, finance, administration, and human development.",
        },
        {
          name: "Luz Marina Lozada A.",
          role: "Partner",
          focus:
            "30+ years in banking and the Ministry of Finance. Organizational processes, BPM, and projects with UNDP and UGPP.",
        },
        {
          name: "Lineth Rodriguez Ruge",
          role: "Partner",
          focus:
            "Executive coach and marketing leader. Director roles at Alpina, El Rey, Belcorp, and Grasco. Commercial team facilitation.",
        },
        {
          name: "José Luis Salas H.",
          role: "Partner",
          focus:
            "MBA (USC) and finance specialist. Strategic, administrative, and commercial development in mass consumption and services.",
        },
        {
          name: "Leidy Ramírez",
          role: "Partner",
          focus:
            "Communications, design, and corporate identity. Branding, editorial, and print to strengthen commercial positioning.",
        },
      ],
      portfolioComplementario: {
        label: "Complementary portfolio",
        title: "A solution ecosystem for your company",
        subtitle:
          "Beyond MEU Aliado's financial innovation leadership, you can activate Open Options' portfolio — our allied company — across three axes: strategic, commercial, and human talent, with business intelligence (BI) tools.",
        downloadPdf: "Download executive portfolio (PDF)",
        downloadPdfHint: "Corporate portfolio with services, team, and Open Options alliance.",
        meuTitle: "Financial innovation leadership · MEU Aliado",
        meuItems: [
          "Initial financial diagnosis and 90-day roadmap.",
          "Essential, Growth, and Strategic plans with KPIs and cash flow.",
          "Special projects: valuations, models, M&A, due diligence, and funding.",
        ],
        meuCta: "View plans and services",
        openOptionsCta: "Explore Open Options",
        pillars: [
          {
            title: "Strategic development",
            items: [
              "Short-, medium-, and long-term strategic planning.",
              "Organizational structure and process management.",
              "Management systems and certification.",
              "Management indicators and business intelligence (Power BI).",
            ],
          },
          {
            title: "Commercial development",
            items: [
              "Sales force support and coaching.",
              "Mystery shopper and purchase experience.",
              "Market research.",
              "Marketing and positioning plans.",
            ],
          },
          {
            title: "Human development",
            items: [
              "Executive assessment and coaching.",
              "Compensation and benefits systems.",
              "Individual and team competency development.",
              "Training and psychosocial risk assessments.",
            ],
          },
        ],
      },
    },
    planes: {
      backLink: "Back to financial innovation leadership",
      eyebrow: "Plans and services",
      title: "Financial innovation leadership",
      subtitle: "Pricing, plan comparison, service scope, initial diagnosis, and engagement terms.",
      downloadPdf: "Download executive portfolio (PDF)",
      nav: [
        { label: "How to start", targetId: "ruta" },
        { label: "Comparison", targetId: "comparativo" },
        { label: "Plans", targetId: "detalle-planes" },
        { label: "Not included", targetId: "no-incluidos" },
        { label: "Add-ons", targetId: "adicionales" },
        { label: "Terms", targetId: "condiciones" },
      ],
      journey: {
        label: "How to start",
        title: "A three-phase path",
        subtitle:
          "Reference pricing for each stage: initial diagnosis, monthly support, and one-off projects.",
        recommended: "Recommended starting point",
        suggestedPlan: "Suggested plan",
        deliverablesLabel: "Deliverables",
        investmentLabel: "Investment",
        phases: [
          {
            phase: "Phase 1",
            title: "Initial financial diagnosis",
            summary: "A low-risk entry point to understand your company's financial position and priorities.",
            price: "COP $1.200.000",
            priceNote: "Typical range: COP $800.000 – COP $1.500.000",
            deliverables: ["Diagnosis", "Findings", "Recommendations", "90-day roadmap"],
            bridge:
              "If you'd like to implement these recommendations, we can do so through our financial innovation leadership engagement model.",
            cta: "Request diagnosis",
            ctaType: "whatsapp",
            recommended: true,
          },
          {
            phase: "Phase 2",
            title: "Financial innovation leadership",
            summary: "Recurring support with meetings, reports, and KPIs — Essential, Growth, and Strategic plans.",
            price: "COP $2.000.000 – COP $6.000.000",
            priceNote: "monthly",
            suggestedPlanName: "Growth",
            suggestedPlanPrice: "$3,500,000",
            description:
              "Growth balances analytical depth and dedication for growing companies. See the comparison table for scope by plan.",
            cta: "View plan comparison",
            ctaType: "anchor",
            ctaHref: "#comparativo",
            suggested: true,
          },
          {
            phase: "Phase 3",
            title: "Special projects",
            summary: "Scope and pricing tailored to each project's complexity and size.",
            price: "Custom pricing",
            deliverables: [
              "Capital raising",
              "Valuations",
              "Financial models",
              "M&A",
              "Due diligence",
              "Financial hedging",
              "Portfolio management",
            ],
            cta: "Discuss a project",
            ctaType: "whatsapp-specialized",
          },
        ],
      },
      comparativoTitle: "Plan comparison",
      tableFeature: "Feature",
      includedAria: "Included",
      ctaWhatsapp: "Request advisory via WhatsApp",
      recommended: "Recommended",
      planPrefix: "Plan",
      monthlyInvestment: "Monthly investment",
      usdPriceNote: "USD pricing · For USA-based companies only",
      includes: "Includes",
      notIncludedTitle: "Services on request",
      notIncludedP1:
        "The following services are not part of the standard scope of financial innovation leadership within the Essential, Growth, and Strategic plans.",
      notIncludedP2:
        "We do offer them and can deliver them upon request, with scope, timeline, and fees agreed separately. Message us on WhatsApp and we'll review what your company needs.",
      featuredServicesLabel: "MEU Aliado highlights",
      featuredCta: "I'm interested",
      requestWhatsapp: "Request via WhatsApp",
      additionalLabel: "Additional services",
      specializedTitle: "Specialized Services",
      tableService: "Service",
      tableDescription: "Description",
      tableDeliverables: "Included deliverables*",
      tableInvestment: "Reference investment*",
      conditionsTitle: "General terms",
    },
    data: {
      planes: [
        {
          nombre: "Essential",
          precio: "$2,000,000",
          horas: "4 to 6 hours per month",
          destacado: false,
          descripcion:
            "For companies that need basic financial visibility and periodic results tracking.",
          incluye: [
            "Monthly financial dashboard.",
            "Revenue, cost, and margin tracking.",
            "Basic cash flow monitoring.",
            "Monthly follow-up meeting.",
            "Executive report with findings and recommendations.",
          ],
        },
        {
          nombre: "Growth",
          precio: "$3,500,000",
          horas: "8 to 12 hours per month",
          destacado: true,
          descripcion:
            "For growing companies that need financial planning and ongoing business control.",
          incluye: [
            "Everything in the Essential plan.",
            "Financial model.",
            "Revenue and expense forecast.",
            "Cash planning.",
            "Strategic KPI tracking.",
            "Periodic profitability analysis.",
            "Two monthly meetings.",
          ],
        },
        {
          nombre: "Strategic",
          precio: "$6,000,000",
          horas: "16 to 24 hours per month",
          destacado: false,
          descripcion:
            "For companies that need senior financial support for growth, expansion, or fundraising.",
          incluye: [
            "Everything in the Growth plan.",
            "Financial evaluation of new projects.",
            "Expansion analysis.",
            "Support in funding processes.",
            "Investor-ready materials.",
            "Participation in strategic meetings.",
            "Priority availability.",
          ],
        },
      ],
      comparativoPlanes: [
        { caracteristica: "Monthly investment", essential: "COP $2,000,000", growth: "COP $3,500,000", strategic: "COP $6,000,000" },
        { caracteristica: "Follow-up meetings", essential: "1 monthly", growth: "2 monthly", strategic: "Weekly" },
        { caracteristica: "Financial dashboard", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Revenue & expense tracking", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Margin tracking", essential: "check", growth: "check", strategic: "check" },
        { caracteristica: "Cash flow", essential: "Basic", growth: "Advanced", strategic: "Advanced" },
        { caracteristica: "Financial forecast", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Financial model", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Strategic KPIs", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Profitability analysis", essential: "dash", growth: "check", strategic: "check" },
        { caracteristica: "Project evaluation", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Expansion analysis", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Funding support", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Investor presentations", essential: "dash", growth: "dash", strategic: "check" },
        { caracteristica: "Email & WhatsApp support", essential: "check", growth: "check", strategic: "Priority" },
      ],
      serviciosDestacados: [
        {
          id: "clientes-agendas",
          titulo: "Automated client and schedule management",
          whatsapp: shared.whatsapp.en.clientesAgendas,
        },
        {
          id: "facturacion-electronica",
          titulo: "Electronic invoicing",
          whatsapp: shared.whatsapp.en.facturacionElectronica,
        },
      ],
      exclusiones: [
        "Accounting.",
        "Tax return preparation.",
        "Statutory audit (revisoría fiscal).",
        "External audit.",
        "Payroll.",
        "Legal services.",
        "Accounting software implementation.",
        "Operational portfolio management.",
        "Transaction bookkeeping.",
      ],
      serviciosEspecializadosIntro:
        "In addition to financial innovation leadership, we offer financial and strategic projects with a defined scope that can be contracted independently or as a complement. Through our alliance with Open Options, you can also activate consulting in strategy, commercial, and human talent.",
      serviciosAdicionales: [
        {
          servicio: "Business valuation",
          descripcion: "Economic value estimation using standard financial methodologies.",
          entregables: [
            "1 Excel — Valuation model (DCF, comparables, sensitivity).",
            "1 PDF — Executive valuation report (15–25 pages).",
            "1 PowerPoint — Board summary (10–12 slides).",
          ],
          inversion: "From COP $2,000,000",
        },
        {
          servicio: "Specialized financial modeling",
          descripcion: "Financial models for planning, investment, or scenario evaluation.",
          entregables: [
            "1–2 Excel — Structured model with base, upside, and stress scenarios.",
            "1 PDF — Methodology note, assumptions, and limitations (5–8 pages).",
            "1 PowerPoint — Scenario summary and conclusions (8–10 slides).",
          ],
          inversion: "From COP $1,500,000",
        },
        {
          servicio: "Business Plan",
          descripcion: "Financial projections and supporting document for growth or funding.",
          entregables: [
            "1 Word / PDF — Business Plan document (25–40 pages).",
            "1 Excel — 3–5 year projections (P&L, cash flow, balance sheet).",
            "1 PowerPoint — Pitch deck for banks or partners (12–15 slides).",
          ],
          inversion: "From COP $2,500,000",
        },
        {
          servicio: "Capital raising preparation",
          descripcion: "Financial structuring, metrics, and materials for investors.",
          entregables: [
            "1 Excel — Financial model and data room metrics.",
            "1 PowerPoint — Investor deck (15–20 slides).",
            "1 PDF — One-pager + capital structure memo (10–15 pages).",
            "1 Word — Q&A guide and due diligence checklist.",
          ],
          inversion: "From COP $3,000,000",
        },
        {
          servicio: "Financial Due Diligence",
          descripcion: "Financial review and analysis for investment or acquisition processes.",
          entregables: [
            "1 Excel — Findings, adjustments, and normalized statements.",
            "1 PDF — Financial due diligence report (20–35 pages).",
            "1 PowerPoint — Executive summary for investment committee (8–10 slides).",
          ],
          inversion: "From COP $4,000,000",
        },
        {
          servicio: "Market studies",
          descripcion: "Sector research, competitive analysis, and opportunity assessment.",
          entregables: [
            "1 PDF — Market and competition report (15–25 pages).",
            "1 Excel — Sector data, benchmarks, and supporting tables.",
            "1 PowerPoint — Conclusions and opportunities (10 slides).",
          ],
          inversion: "From COP $2,000,000",
        },
        {
          servicio: "Acquisition financial evaluation",
          descripcion: "Financial and strategic analysis of potential acquisitions or investments.",
          entregables: [
            "1 Excel — Acquisition model, synergies, and return.",
            "1 PDF — Go / no-go recommendation memo (12–18 pages).",
            "1 PowerPoint — Board decision summary (8–12 slides).",
          ],
          inversion: "From COP $3,500,000",
        },
        {
          servicio: "Management KPI design",
          descripcion: "KPI and dashboard design for business monitoring.",
          entregables: [
            "1 Excel — KPI dashboard with formulas and agreed segmentation.",
            "1 PDF — Indicator dictionary and methodology (8–12 pages).",
            "1 PowerPoint — Management presentation (6–8 slides).",
          ],
          inversion: "From COP $1,000,000",
        },
        {
          servicio: "Financial hedging",
          descripcion:
            "Design and support for hedging strategies to mitigate FX, interest rate, or other risks affecting operations or results.",
          entregables: [
            "1 Excel — Exposure model and hedging scenarios.",
            "1 PDF — Strategy memo and recommended instruments (8–15 pages).",
            "1 PowerPoint — Risk committee proposal (6–10 slides).",
            "Scope and deliverable count customized by complexity.",
          ],
          inversion: "Custom pricing",
        },
        {
          servicio: "Portfolio management",
          descripcion:
            "Portfolio management with strategies aligned to economic and business cycles. We manage corporate accounts via outsourcing, without fund-raising activities, through regulated wealth management entities.",
          entregables: [
            "1 PDF — Investment policy and agreed risk profile.",
            "1 Excel — Monthly composition and performance report.",
            "1 PowerPoint — Quarterly portfolio review (8–12 slides).",
            "Periodic PDF reports from the regulated entity (per contract).",
          ],
          inversion: "From COP $150,000,000",
        },
      ],
      serviciosEspecializadosNota:
        "Prices and deliverable quantities are reference values per project. Scope, complexity, information availability, and company size may change the quote and number of files (Excel, PDF, PowerPoint, or Word) included.",
      condicionesGenerales: [
        "Monthly billing in advance.",
        "Professional services agreement.",
        "Suggested minimum commitment of three (3) months.",
        "All information provided by the company will be treated confidentially.",
      ],
    },
    whatsapp: shared.whatsapp.en,
  },
};
